'use client';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "SHOW";
    ACTIONS["FORCE_CONTROL"] = "FORCE_CONTROL";
    ACTIONS["SET_KEYWORD"] = "SET_KEYWORD";
    ACTIONS["SET_TOP_JOB_ITEM"] = "SET_TOP_JOB_ITEM";
    ACTIONS["SET_HOT_KEYWORDS"] = "SET_HOT_KEYWORDS";
    ACTIONS["SET_SUGGESTIONS"] = "SET_SUGGESTIONS";
    ACTIONS["BLUR_BACKGROUND"] = "BLUR_BACKGROUND";
    ACTIONS["SET_HIGHLIGHT_JOB"] = "SET_HIGHLIGHT_JOB";
    ACTIONS["SET_FIRST_TIME_LOAD"] = "SET_FIRST_TIME_LOAD";
    ACTIONS["OPEN_DROP_DOWN"] = "OPEN_DROP_DOWN";
    ACTIONS["CLOSE_DROP_DOWN"] = "CLOSE_DROP_DOWN";
    ACTIONS["UPDATE_SELECTED_SUGGESTION_INDEX"] = "UPDATE_SELECTED_SUGGESTION_INDEX";
    ACTIONS["TOGGLE_LOCK_DEBOUNCE"] = "TOGGLE_LOCK_DEBOUNCE";
    ACTIONS["SET_JOB_YOU_WILL_LOVE"] = "SET_JOB_YOU_WILL_LOVE";
    ACTIONS["SET_SEARCH_JOB_YOU_LOVE"] = "SET_SEARCH_JOB_YOU_LOVE";
    ACTIONS["SET_RECENT_KEYWORDS"] = "SET_RECENT_KEYWORDS";
    ACTIONS["SET_LOCATIONS"] = "SET_LOCATIONS";
})(ACTIONS || (ACTIONS = {}));

export { ACTIONS };
//# sourceMappingURL=actions.js.map
